/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.Form = (function () {

    function PanelBuilderForm (pageLayout, entity) {

        Monet.Builder.Form.Base.apply(this, arguments);

        this.fields = [];
        this.entityToAction = 'RouteView';
        this.orderManager = new Greenmile.PanelBuilder.OrderByManager(this);
        this.filterManager = new Greenmile.PanelBuilder.FilterByManager(this);
        this.ruleManager = new Greenmile.PanelBuilder.RuleManager(this);
        const panelBuilderRouter = App.Objects.PanelBuilder;

        let clearContent = () => {
            this.fields.restrictToOrganizations.clear();
            document.querySelector(".formattedValue.lookUpField").value = '';
        };

        var getGeneralDataSection = function () {

            const container = document.createElement('div');
            container.className = 'generalData';

            const columnLeft = document.createElement('div');
            columnLeft.className = 'generalData__column-left';

            const columnRight = document.createElement('div');
            columnRight.className = 'generalData__column-right';

            const name = new Monet.UI.Fields.Render({
                maxSize: 45,
                label: 'panelbuilder.name',
                name: 'name',
                mandatory: true,
                type: 'TEXT'
            }, entity).render();

            this.fields.name = name;

            const organizations = new Monet.UI.Fields.Render({
                label: 'panelbuilder.organizations',
                name: 'organizations',
                mandatory: false,
                type: 'POWER_LOOKUP_LIST_FILTER',
                lookupEntity: 'Organization',
                lookupEntityColumn: 'description'
            }, 'Organization').render();

            this.fields.restrictToOrganizations = organizations;

            const constainersToCheckboxs = { openAtLogin: 'openAtLogin', showTotals: 'showTotals' };
            [
                constainersToCheckboxs.openAtLogin, 
                constainersToCheckboxs.showTotals
            ].forEach(function (fieldName) {
                this.fields[fieldName] = new Monet.UI.Fields.Render({
                    label: 'Greenmile.PanelBuilder.' + fieldName,
                    name: fieldName,
                    mandatory: false,
                    type: 'CHECKBOX'
                }, entity).render();
            }, this);

            const clearLabel = document.createElement("span");
            clearLabel.innerText = Monet.I18n.getResourcesByKey("lookupList.removeAllElements");
            clearLabel.classList.add("remove-element");
            clearLabel.addEventListener("click", clearContent);
            organizations.rootEl.appendChild(clearLabel);

            columnLeft.appendChild(name.rootEl);
            columnLeft.appendChild(this.fields[constainersToCheckboxs.openAtLogin].rootEl);
            columnLeft.appendChild(this.filterManager.getFilterBySection());
            container.appendChild(columnLeft);

            columnRight.appendChild(organizations.rootEl);
            columnRight.appendChild(this.fields[constainersToCheckboxs.showTotals].rootEl);
            columnRight.appendChild(this.orderManager.getOrderBySection());
            container.appendChild(columnRight);

            return container;

        }.bind(this);

        var getCardSection = function () {

            this.buildCard = new Greenmile.PanelBuilder.BuildCard;

            var container = document.createElement('div'),
            title = this.getTitleSection('Greenmile.PanelBuilder.BuildCard'),
            cardRootEl = this.buildCard.render();
            container.className = 'cardSection';
            container.appendChild(title);

            var linkToRoute = cardRootEl.querySelector('a.go-to-routedetail');
            linkToRoute.removeAttribute('href');

            container.appendChild(cardRootEl);

            return container;
        }.bind(this);

        var setGeneralDataValue = function (data) {
            this.id = data.id;
            this.fields.name.setValue(data.name);
            this.fields.restrictToOrganizations.setValue(data.restrictToOrganizations);
            this.fields.openAtLogin.setValue(data.openAtLogin);
            this.fields.showTotals.setValue(data.showPercentage);

        }.bind(this);

        this.setValue = function (data) {
            if (data) {
                this.value = data;
                setGeneralDataValue(data);
                this.buildCard.setValues(data.panelCardFields);
                this.orderManager.setValues(data.panelOrderFilters);
                this.ruleManager.setValues(data.panelRules);
                this.filterManager.setValues(data.panelFilters);

            }
            this.fields.restrictToOrganizations.postRender();
        }.bind(this);

        this.getValues = function () {

            var value = {
                name: this.fields.name.getValue(),
                rootEntity: {
                    "key": this.entityToAction
                },
                openAtLogin: this.fields.openAtLogin.getValue(),
                showPercentage: this.fields.showTotals.getValue(),
                panelOrderFilters: this.orderManager.getOrderFiltersValue(),
                panelFilters: this.filterManager.getFiltersValue(),
                restrictToOrganizations: this.fields.restrictToOrganizations.getValue(),
                panelCardFields: this.buildCard.getValues(),
                panelRules: this.ruleManager.getRulesValue(),
                cardSideToShow : this.buildCard.getSideCardToShow()
            };

            if (this.id) {
                value.id = this.id;
            }

            return value;

        };

        var renderSaveButton = function (callbackFunction) {
            const topButtonsContainer = document.querySelector('#PanelBuilder #topButtonsContainer');
            const input = document.querySelector('#PanelBuilder #topButtonsContainer input');
            input && input.parentNode.removeChild(input);

            if (topButtonsContainer && Greenmile.PanelBuilder.Utils.checkPermissions('PANEL_BUILD')) {
                const buttonDataType = {
                    label: "panelbuilder.button.save",
                    type: "BUTTON",
                    customJavaScript: null,
                    name: "btn_save"
                };
                const fieldRender = new Monet.UI.Fields.Render(buttonDataType, entity);
                const buttonField = fieldRender.render(buttonDataType);
                const renderedButton = buttonField.rootEl;
                renderedButton.setAttribute('name', buttonDataType.name);
                renderedButton.className = 'button save';
                renderedButton.value = Monet.I18n.getResourcesByKey('default.button.save');
                if(!this.buttons[buttonDataType.name]) {
                    this.buttons[buttonDataType.name] = [];
                }

                this.buttons[buttonDataType.name].push(buttonField);
            
                renderedButton.addEventListener('click', function () {
                    callbackFunction();
                });

                topButtonsContainer.appendChild(renderedButton);
            }
            
        }.bind(this);

        this.getTitleSection = function (title) {
            var listTitleContainer = document.createElement('div');
            var listTitle = document.createElement('div');

            listTitleContainer.className = 'titleContainer';
            listTitle.className = 'title';

            listTitle.innerHTML = Monet.I18n.getResourcesByKey(title);

            listTitleContainer.appendChild(listTitle);

            return listTitleContainer;
        }.bind(this);

        const successfulUpdateAlert = () => {
            panelBuilderRouter.list();
          const monetMessage = new Monet.Form.Messages.InlineMessage();
          monetMessage.setScope("#PanelBuilder");
          monetMessage.setInfoType("success");
          monetMessage.setMessage(Monet.I18n.getResourcesByKey('panelBuilder.sucessfulUpdate'));
          monetMessage.triggerMessage();
          setTimeout(() => {
            monetMessage.destroy();
          }, 3000);
        };

        this.render = function () {
            var baseForm = this.renderBaseForm();
            var allContent = baseForm.allContent;
            var formContent = document.createElement('div');
            formContent.className = 'formcontent';

            renderSaveButton(function () {
                var id = App.Forms.PanelBuilder.form.value ? App.Forms.PanelBuilder.form.value.id : false;
                if (!id) {
                    panelBuilderRouter.create(panelBuilderRouter.list);
                } else {
                    panelBuilderRouter.update(successfulUpdateAlert);
                }
            });

            var titleGeneralDataSection = this.getTitleSection('Greenmile.Panel.DataTitle');
            var GeneralDataSection = document.createElement('div');
            GeneralDataSection.className = 'GeneralDataSection';
            GeneralDataSection.appendChild(titleGeneralDataSection);
            GeneralDataSection.appendChild(getGeneralDataSection());
            
            formContent.appendChild(GeneralDataSection);
            formContent.appendChild(getCardSection());
            formContent.appendChild(this.ruleManager.getRulesSection());

            allContent.appendChild(formContent);

            return allContent;
        };

        this.postRender = function () {
            this.fields.restrictToOrganizations.postRender();
            var filters = this.filterManager.filters;
            for (var i in filters) {
                filters[i].filter.postRender();
            }
        };
    }

    return PanelBuilderForm;

}());